<template>
  <div class="overall-bg">
    <b-container fluid="xl">
      <b-row>
        <b-col>
          <BacktoPage :goback="$router.back" />
          <Headerlayout :headertext="$t('ItemCategory.GroupMaster.List')"
            :contenttext="$t('ItemCategory.GroupMaster.TableHeaderContent')" />
        </b-col>
      </b-row>
      <b-row class="py-3">
        <div v-if="windowWidth > 545">
          <SkeletonTableLoader :columns="headers" :loading="loading" />
          <div v-if="!loading">
            <MasterEmpty v-if="items.length === 0 && !loading" eheader="Sub Category Master"
              econtent="Sub Category Master" eimg="/src/assets/Img/icons/groupmaster.svg" @createNew="IsAdd" />
            <div class="">
              <Tableview v-if="items.length != 0" :value="items" :paginator="true" class="p-datatable-gridlines"
                :rows="10" :rowHover="true" filterDisplay="menu" :loading="loading1" responsiveLayout="scroll"
                :exceldownload="true" :columns="headers" :globalFilterFields="globalFilterFields" :filters="filters"
                selectionMode="single">
                <template v-slot:Add>
                  <span class="add">
                    <AddButton @click="IsAdd()" :btnname="$t('btn.plusaddnew')" class="float-rights my-3"></AddButton>
                  </span>
                </template>
                <template v-slot:exceldownload>
                  <ExportOption @ExportExcel="ExportExcel" @ExportPDF="ExportPDF" :ExportList="ExportList"
                    PageName="Sub Category Master" :ExportOption="ExportOption" class="ms-2" :HideAndShow="true" />
                </template>
                <template v-slot:Subgroup="{ data }">
                  <p @click="
                    navigatetopage(
                      'subgroupTableview',
                      data.subgroupCount,
                      data
                    )
                    ">
                    {{ data.subgroupCount }}
                  </p>
                </template>
                <template v-slot:Status="{ data }">
                  <!-- <Badge v-if="data.Status == '0'" severity="warning">{{
                    "InActive"
                  }}</Badge>
                  <Badge v-if="data.Status == '1'" severity="success">{{
                    "Active"
                  }}</Badge> -->
                  <OrangeStatus name="InActive" v-if="data.Status == '0'" />
                  <GreenStatus name="Active" v-if="data.Status == '1'" />
                </template>
                <template v-slot:action="{ data }">
                  <span>
                    <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                      @click="toggle($event, data)" />
                  </span>
                </template>
              </Tableview>
            </div>
          </div>
        </div>
        <div v-if="windowWidth <= 545">
          <MobileLoader v-if="loading" />
          <div v-if="!loading">
            <MasterEmpty v-if="items.length === 0 && !loading" eheader="Group Master" econtent="Group Master"
              eimg="/src/assets/Img/icons/groupmaster.svg" @createNew="IsAdd" />
            <MobileViewCardHeader>
              <template v-slot:mobilecard>
                <div class="mobile-card" v-for="item in items">
                  <div class="d-flex align-items-center justify-content-between gap-2">
                    <div>
                      <p class="light-name">{{ item.Code }}</p>
                      <p class="name">{{ item.Name }}</p>
                    </div>
                    <div class="d-flex align-items-center">
                      <div>
                        <!-- <Badge v-if="item.Status == '0'" severity="warning">{{
            "InActive"
          }}</Badge>
                        <Badge v-if="item.Status == '1'" severity="success">{{
            "Active"
          }}</Badge> -->
                        <OrangeStatus name="InActive" v-if="item.Status == '0'" />
                        <GreenStatus name="Active" v-if="item.Status == '1'" />
                      </div>
                      <i class="pi pi-ellipsis-v" @click="toggle($event, item)"></i>
                    </div>
                  </div>
                  <p class="light-name">{{ item.CategoryName }}</p>
                  <div class="d-flex align-items-center gap-2">
                    <p class="light-name">Sub Group :</p>
                    <p class="small-name">{{ item.subgroupCount }}</p>
                  </div>
                </div>
              </template>
            </MobileViewCardHeader>
          </div>
        </div>
        <GroupCreation v-model:trigger="showDialog" v-if="showDialog" v-model:selected-item="editItems"
          @load="IsShow(), (showDialog = false)" @close="showDialog = false" @loaderhide="loading = false"
          @loadershow="loading = true" :OperationID="ObjOperationId" :EntityId="EntityData.EntityId" />
      </b-row>
    </b-container>
  </div>
  <Menu ref="menu" id="overlay_menu" :model="itemListed" @click="" :popup="true" />
  <EditConfirmation :Editmodel="Editmodel" @yes="IsEdit(dataEdit)" @no="Editmodel = false"
    :content="$t('confirmation.editcontent')" />
  <DeleteConfirmationVue :DeleteModel="Deletemodel" :content="contentdel" @yes="Isdelete(dataEdit)"
    @no="Deletemodel = false" />
  <DeletedSuccessfully :visible="deletepop" @ok="closetrigger()" />
  <ActivatedSuccessfully :visible="pop.activatepop" @ok="closetrigger()" />
  <InActivatedSuccessfully :visible="pop.inactivepop" @ok="closetrigger()" />
  <Mapping :visible="MappingPop.visible" @ok="closetrigger()" :content="MappingPop.content" />
  <Toast />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, h, computed, onUnmounted } from "vue";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";

import Headerlayout from "../../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../../components/FormComponents/BacktoMaster.vue";
import GroupCreation from "../../../Masters/ItemCategory/GroupMaster/GroupCreation.vue";
import GroupService from "../../../../../../modules/Inventory/Service/GroupService";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import ActivatedSuccessfully from "../../../../../../components/FormComponents/ActivateSuccessfully.vue";
import InActivatedSuccessfully from "../../../../../../components/FormComponents/InActivateSuccessfully.vue";
import Tableview from "../../../../../../components/FormComponents/Table.vue";
import { useI18n } from 'vue-i18n';
import EditConfirmation from "../../../../../../components/FormComponents/EditConfirmation.vue";
import DeleteConfirmationVue from "../../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../../components/FormComponents/DeletedSuccessfully.vue";
import Mapping from "../../../../../../components/FormComponents/Mapping.vue";
import MasterEmpty from "../../../../../../components/Masters/MasterEmpty.vue";
import Loader from "../../../../../../components/FormComponents/Loader.vue";

import MastersService from "../../../../Service/MastersService";
import { useToast } from "primevue/usetoast";
import { checkPermission } from "../../../../Service/AccessControl";
import SkeletonTableLoader from "../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from "../../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import ExportOption from "../../../../../../components/FormComponents/Export.vue";

export default defineComponent({
  components: {
    Mapping,
    EditConfirmation,
    DeletedSuccessfully,
    DeleteConfirmationVue,
    BacktoPage,
    Headerlayout,
    GroupCreation,
    Tableview,
    MasterEmpty,
    Loader,
    ActivatedSuccessfully,
    InActivatedSuccessfully,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
    ExportOption,
  },
  setup() {
    const toast = useToast();
    const showDialog = ref(false);
    const dataEdit = ref();
    const Editmodel = ref(false);
    const { t } = useI18n();
    const rowFocus = ref(false);
    const editItems = ref();
    const Deletemodel = ref(false);
    const deletepop = ref(false);
    let MappingPopup = ref(false);
    let ContentName = ref("");

    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
    });
    function IsAdd() {
      let permissionResult: any = checkPermission(Rights, "Add");
      if (permissionResult.hasPermission) {
        showDialog.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }
    let loading1 = ref(false);
    let loading = ref(false);

    function RowClick(event: any) {
      debugger;
      Editmodel.value = true;
      rowFocus.value = true;
      dataEdit.value = event.data;
    }

    function IsConfirmEdit(data) {
      debugger;

      let permissionResult: any = checkPermission(Rights, "Edit");
      if (permissionResult.hasPermission) {
        dataEdit.value = data;
        Editmodel.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    const contentdel = ref("");
    const pop = ref({
      activatepop: false,
      inactivepop: false,
    });

    function IsConfirmDel(data, Status) {
      debugger;

      let permissionResult: any = checkPermission(Rights, "Delete");
      if (permissionResult.hasPermission) {
        data.ActiveStatus = Status;
        dataEdit.value = data;
        Editmodel.value = false;
        if (Status == 1) {
          contentdel.value = t('confirmation.activecontent');
        } else if (Status == 2) {
          contentdel.value = t('confirmation.inactivecontent');
        } else {
          contentdel.value = t('confirmation.deletecontent');
        }
        Deletemodel.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }
    // Popup-Close
    function closetrigger() {
      deletepop.value = false;
      pop.value.activatepop = false;
      pop.value.inactivepop = false;
      MappingPop.value.visible = false;
    }
    function closemapping() {
      MappingPopup.value = false;
      Deletemodel.value = false;
    }
    const router = useRoute();
    let route = useRouter();
    let categoryId = router.query.categoryId;

    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    let SessionEntityData = localStorage.getItem("EntityData");
    let EntityData;
    if (SessionEntityData !== null) {
      EntityData = JSON.parse(SessionEntityData);
    }
    //

    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

    onMounted(() => {
      window.addEventListener("resize", handleResize);
      document.addEventListener("keydown", onKeyUp);
      FunctionRights();
      IsShow();
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });

    let Rights = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });

    async function FunctionRights() {
      //
      debugger;
      const response = await MastersService.CheckMenuRights(
        EntityData.EntityId,
        rolesData.RoleId
      );
      console.log(response["result"]);

      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          ObjOperationId.value.CreateId = operation.OperationID;
          Rights.value.Create = operation.IsActive;
        } else if (operation.OperationName === "Update") {
          ObjOperationId.value.UpdateId = operation.OperationID;
          Rights.value.Update = operation.IsActive;
        } else if (operation.OperationName === "Read") {
          ObjOperationId.value.ReadId = operation.OperationID;
          Rights.value.Read = operation.IsActive;
        } else if (operation.OperationName === "Delete") {
          ObjOperationId.value.DeleteId = operation.OperationID;
          Rights.value.Delete = operation.IsActive;
        }
      }
    }

    function onKeyUp(event: any) {
      debugger;

      console.log(dataEdit.value);
      if (
        (event.key == "e" ||
          (Editmodel.value == false && event.key == "Enter")) &&
        rowFocus.value == true &&
        Deletemodel.value == false &&
        showDialog.value == false
      ) {
        // IsEdit(dataEdit.value)
        Editmodel.value = true;
      } else if (
        event.altKey &&
        event.key == "n" &&
        Editmodel.value == false &&
        Deletemodel.value == false
      ) {
        IsAdd();
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Deletemodel.value == true &&
        Editmodel.value == false &&
        rowFocus.value == true
      ) {
        Isdelete(dataEdit.value);
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Editmodel.value == true &&
        rowFocus.value == true
      ) {
        IsEdit(dataEdit.value);
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Editmodel.value == true
      ) {
        Editmodel.value = false;
      } else if (
        event.key == "d" &&
        rowFocus.value == true &&
        showDialog.value == false &&
        Editmodel.value == false
      ) {
        Deletemodel.value = true;
        Editmodel.value = false;
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Deletemodel.value == true
      ) {
        Deletemodel.value = false;
      } else if (event.key == "Escape" && deletepop.value == true) {
        deletepop.value = false;
      } else if (event.key == "Enter" && rowFocus.value == false) {
        Editmodel.value = false;
      } else if (event.key == "Escape" && MappingPopup.value == true) {
        MappingPopup.value = false;
        Deletemodel.value = false;
      }
    }

    //Edit Box
    function IsEdit(data) {
      debugger;
      editItems.value = data;
      showDialog.value = true;
      Editmodel.value = false;
    }

    let groupref = ref();
    const headers = [
      {
        header: t('ItemCategory.GroupMaster.sno'),
        field: "RowNumber",
        class: "filterdisplaynone smallwidth",
      },
      {
        header: t('ItemCategory.GroupMaster.Code'),
        field: "Code",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t('ItemCategory.GroupMaster.Name'),
        field: "Name",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow1",
        class: "mediumwidth",
      },
      {
        header: t('ItemCategory.GroupMaster.Catname'),
        field: "CategoryName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow1",
        class: "mediumwidth",
      },
      {
        header: t('ItemCategory.GroupMaster.SubGroup'),
        field: "subgroupCount",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        slot: "Subgroup",
        fieldDisplay: "false",
        bodyclass: "bluecolor",
        class: "smallwidth",
      },
      {
        header: t('ItemCategory.GroupMaster.Status'),
        field: "ActiveStatus",
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        slot: "Status",
      },
      {
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        fieldDisplay: "false",
        class: "filterdisplaynone last-column-position",
      },
    ];

    // Table data Array
    let items: any = ref([]);

    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      Code: { value: null, matchMode: FilterMatchMode.IN, options: items },
      Name: { value: null, matchMode: FilterMatchMode.IN, options: items },
      CategoryName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      subgroupCount: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      ActiveStatus: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
    };

    const filteredColumns = computed(() => {
      return headers.filter((col) => col.field !== "id");
    });
    const globalFilterFields = ref(headers.map((col) => col.field));
    const MappingPop = ref({
      visible: false,
      content: "",
    });

    let ExportOption = ref("");
    let ExportList = ref([]);


    function ExportExcel() {
      debugger;
      ExportOption.value = "Excel";
      IsShowExport();
    }

    function ExportPDF() {
      debugger;
      ExportOption.value = "PDF";
      IsShowExport();
    }

    async function IsShowExport() {
      debugger;
      try {
        loading.value = false;
        const response = await GroupService.getdata();
        console.log(response);
        let count = 0;

        response["result"] = response["result"]
          .filter((items) => items.HospitalId == usersData.OrganizationId)
          .map((item) => {
            item.ActiveStatus = item.Status == 1 ? "Active" : "Inactive";
            count = count + 1;
            item.RowNumber = count;
            return item;
          });

        if (categoryId) {
          items.value = response["result"].filter(
            (item) => item.ProductTypeId == categoryId
          );
        } else {
          items.value = response["result"];
        }

        ExportList.value = response["result"].map((item) => {
          const filteredItem = {};

          headers.forEach(({ header, field }) => {
            filteredItem[header] = item[field];
          });

          return filteredItem;
        });

        console.log("ContactTable Data", items.value);

        loading.value = false;
      } catch (error) {
        loading.value = false;
      }
    }


    //Delete Function
    const Isdelete = async (data) => {
      loading.value = true;
      debugger;
      try {
        let response: any = "";
        if (data.ActiveStatus == 0) {
          response = await GroupService.deletedata(data.Id);
        } else {
          let status = data.ActiveStatus == 1 ? true : false;
          response = await GroupService.active(data.Id, status);
        }
        let message = response["ErrorInfo"].ErrorCode;
        loading.value = false;
        if (response["result"] != "False" && message == null) {
          Deletemodel.value = false;
          MappingPop.value.content = response["result"];
          loading.value = false;

          MappingPop.value.visible = true;
        } else if (message == null) {
          if (data.ActiveStatus == 1) {
            pop.value.activatepop = true;
          } else if (data.ActiveStatus == 2) {
            pop.value.inactivepop = true;
          } else {
            deletepop.value = true;
          }
          Deletemodel.value = false;
          rowFocus.value = false;
          IsShow();
        }
      } catch (error) {
        loading.value = false;
        alert(error);
      }
    };

    function navigatetopage(pagename, datacount, datas) {
      if (datacount != 0) {
        route.push({
          name: pagename,
          path: "/" + pagename,
          query: {
            groupId: datas.Id,
          },
        });
      } else {
        alert("Somthing went wrong");
      }
    }

    //Table Function
    const IsShow = async () => {
      loading.value = true;
      try {
        debugger;
        const response = await GroupService.getdata();
        console.log(response);
        let count = 0;

        response["result"] = response["result"]
          .filter((items) => items.HospitalId == usersData.OrganizationId)
          .map((item) => {
            item.ActiveStatus = item.Status == 1 ? "Active" : "Inactive";
            count = count + 1;
            item.RowNumber = count;
            return item;
          });

        if (categoryId) {
          items.value = response["result"].filter(
            (item) => item.ProductTypeId == categoryId
          );
        } else {
          items.value = response["result"];
        }

        loading.value = false;
        console.log(items.value);
      } catch (error) {
        loading.value = false;
        alert(error);
      }
    };
    let objectdata = ref({});
    let InActivevisible = ref();
    let Editvisible = ref();

    let Activevisible = ref();
    let Deletevisible = ref();
    const toggle = (event, data) => {
      debugger;
      console.log(event);
      objectdata.value = data;
      if (data.Status == 0) {
        InActivevisible.value = false;
        Activevisible.value = true;
        Editvisible.value = false;
      } else {
        InActivevisible.value = true;
        Activevisible.value = false;
        Editvisible.value = true;
      }
      menu.value.toggle(event);
    };
    const menu = ref();
    const itemListed = ref([
      {
        items: [
          {
            label: "Edit",
            icon: "editicon pi pi-pencil",
            visible: Editvisible,
            command: async () => {
              IsConfirmEdit(objectdata.value);
            },
          },
          {
            label: "Delete",
            icon: "deleteicon pi pi-trash",
            visible: true,
            command: async () => {
              IsConfirmDel(objectdata.value, 0);
            },
          },

          {
            label: "Active",
            icon: "editicon pi pi-check-circle",
            visible: Activevisible,
            command: async () => {
              IsConfirmDel(objectdata.value, 1);
            },
          },
          {
            label: "InActive",
            icon: "deleteicon pi pi-minus-circle",
            visible: InActivevisible,
            command: async () => {
              IsConfirmDel(objectdata.value, 2);
            },
          },
        ],
      },
    ]);

    return {
      ObjOperationId,
      navigatetopage,
      contentdel,
      MappingPop,
      pop,
      toggle,
      menu,
      itemListed,
      closemapping,
      ContentName,
      IsAdd,
      RowClick,
      dataEdit,
      Editmodel,
      IsEdit,
      IsConfirmEdit,
      IsConfirmDel,
      showDialog,
      editItems,

      Deletemodel,
      deletepop,
      closetrigger,
      Isdelete,
      IsShow,
      headers,
      items,
      groupref,
      filters,
      globalFilterFields,
      filteredColumns,
      loading1,
      loading,
      windowWidth,
      ExportExcel,
      ExportOption,
      ExportPDF,
      ExportList,
      EntityData
    };
  },
});
</script>

<style lang="scss" scoped>
.mobilecategoryname {
  font-size: 16px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  margin-top: -7px;
}

.mobilestorename {
  font-size: 14px;
  color: #999999;
}

.mobilestorelabel {
  font-size: 14px;
  font-weight: 600;
}
</style>
